import { createSelector } from 'reselect';

import { armstrongV1Selector } from '@xingternal/platform-layout-selectors';

export default createSelector(armstrongV1Selector, (armstrongV1) => {
  return {
    armstrongV1,
  };
});
